/**
 * Segnalare un puzzle e bloccare chi l'ha mandato (#65).
 *
 * La segnalazione è un documento in `reports/`, con id `<puzzleId>_<uid>`: le
 * regole ne accettano una per persona per puzzle, e una Cloud Function la
 * inoltra a chi modera. Il blocco è una lista sul proprio profilo.
 */
import logger from "./logger";

export const MOTIVI = ["sexual_violent", "hate_harassment", "illegal", "spam", "other"];

async function firestore() {
  const [{ auth, db }, fs] = await Promise.all([import("./firebase"), import("firebase/firestore")]);
  const uid = auth.currentUser && auth.currentUser.uid;
  if (!uid) throw new Error("not-signed-in");
  return { uid, db, fs };
}

const SEGNALATI = "puzzly.reportedPuzzles";

function segnalatiQui() {
  try {
    return JSON.parse(window.localStorage.getItem(SEGNALATI) || "[]");
  } catch (_) {
    return [];
  }
}

function ricordaSegnalato(puzzleId) {
  try {
    const lista = segnalatiQui();
    if (!lista.includes(puzzleId)) {
      window.localStorage.setItem(SEGNALATI, JSON.stringify([...lista, puzzleId].slice(-200)));
    }
  } catch (_) {
    /* senza storage si rischia solo un doppio invio, che le regole rifiutano */
  }
}

/**
 * @returns {Promise<{already: boolean}>} `already` se da questo dispositivo il
 *          puzzle era già stato segnalato: per chi segnala è comunque fatto.
 *
 * Un rifiuto delle regole NON viene letto come «già segnalato»: se le regole
 * non fossero pubblicate, ogni segnalazione verrebbe rifiutata e l'utente
 * vedrebbe «fatto» senza che niente sia arrivato. Qui deve restare un errore.
 */
export async function reportPuzzle({ puzzleId, reason, note }) {
  if (!MOTIVI.includes(reason)) throw new Error(`motivo non valido: ${reason}`);
  if (segnalatiQui().includes(puzzleId)) return { already: true };
  const { uid, db, fs } = await firestore();
  const testo = (note || "").trim().slice(0, 500);
  await fs.setDoc(fs.doc(db, "reports", `${puzzleId}_${uid}`), {
    puzzleId,
    reporterUid: uid,
    reason,
    ...(testo ? { note: testo } : {}),
    createdAt: fs.serverTimestamp(),
  });
  ricordaSegnalato(puzzleId);
  logger.info("puzzle segnalato", { puzzleId, reason });
  return { already: false };
}

export async function blockOwner(ownerUid) {
  if (!ownerUid) return;
  const { uid, db, fs } = await firestore();
  if (ownerUid === uid) return;
  await fs.updateDoc(fs.doc(db, "users", uid), { blockedOwnerUids: fs.arrayUnion(ownerUid) });
  logger.info("creatore bloccato", { ownerUid });
}

/** Chi ha mandato questo puzzle è fra quelli che ho bloccato? */
export function isBlocked(profile, ownerUid) {
  return !!(ownerUid && profile && Array.isArray(profile.blockedOwnerUids) && profile.blockedOwnerUids.includes(ownerUid));
}
